import { GoogleMapCoord } from 'marketplace/src/components/GoogleMap';

interface Bounds {
  sw: GoogleMapCoord;
  ne: GoogleMapCoord;
}

export const checkBounds = (
  space: {
    venue: {
      address?: { latitude?: number | null; longitude?: number | null } | null;
    };
  },
  bounds?: Bounds | null,
) => {
  if (!bounds) {
    return true;
  }
  const venue = space.venue;
  const address = venue.address;
  const latitude = address?.latitude;
  const longitude = address?.longitude;
  if (!latitude || !longitude) {
    return false;
  }
  return (
    latitude >= bounds.sw.lat &&
    latitude <= bounds.ne.lat &&
    longitude >= bounds.sw.lng &&
    longitude <= bounds.ne.lng
  );
};
